import { adapterOrganizationSingle } from "./adapter-organization-single"

function adapterOrganization(account){
  let result = {}
  if(account.organisasi && account.organisasi[0]){
    const organisasi = account.organisasi[0]

    result = {
      typeAccount: account.typeAccount ? account.typeAccount.id : '',
      accountId: account.accountId,
      ...adapterOrganizationSingle(organisasi)
    }
  }

  return result
}

export { adapterOrganization }
